import Vue from "vue";

Vue.http.options.root = "/root";

// 登录已过期（会话超时、服务重启）时服务端返回的错误码
const SESSION_EXPIRED_CODE = 401;
const RELOAD_KEY = "hy-session-reload-at";

// 刷新页面会重新走一遍微信授权，但如果授权本身出了问题，
// 无限刷新会让页面一直闪，所以 10 秒内只刷新一次，之后改为提示
function reloadForLogin() {
    try {
        let last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
        if (Date.now() - last > 10 * 1000) {
            sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
            location.reload();
            return true;
        }
    } catch (e) {
        // 隐私模式下 sessionStorage 不可用，直接提示
    }
    return false;
}

Vue.http.interceptors.push(function(request, next) {
    next(function(res) {
        if (res.status == 200) {
            res.code = res.body.code;
            res.body = res.body.data;
            if (res.code == SESSION_EXPIRED_CODE) {
                if (!reloadForLogin()) alert(res.body);
            } else if (res.code) {
                alert(res.body);
            }
        } else {
            // 以前非 200（服务异常、网络断开）时没有任何提示，点了按钮像没反应一样；
            // 同时打上 code，调用方 then 里的 if (res.code) return 才能挡住后面的「提交成功」
            res.code = res.status || -1;
            alert("网络异常，请稍后重试");
        }
    });
});
